<template lang="pug">
	.template-create(v-if="showed" v-window)
		.card
			.card-header
				span Create {{ getTypeTitle() }} template
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label Template title
						input.form-control.title(size="16" type="text" v-model="title" @change="updateTemplate")
					.form-group
						label.col-form-label Template description
						textarea.form-control.description(rows="2" v-model="description" @change="updateTemplate")
					.form-group.sizes.separator
						label.col-form-label Sizes
						.sizes-list(v-if="displaySizes.length")
							.size-item(v-for="size in displaySizes" :key="size.sizeKey" :class="{filled: !!size.file}")
								span.size {{ size.title || (size.width + ' x ' + size.height) }}
								span.dimensions.text-muted {{ size.width }} x {{ size.height }}
								span.filename.text-muted(v-if="size.file") {{ size.file.originalFilename }}
								span.filename.text-muted(v-else) Psd file not uploaded yet
								i.fa.fa-remove.remove(v-if="size.file" @click="removeSize(size.file)" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Remove this size'}")
						.text-muted.no-sizes(v-else) No psd files uploaded yet. Upload one psd file for each template size.
					.progress.add-progress(:style="{visibility: uploading ? 'visible' : 'hidden'}")
						.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (uploadProgress * 100) + '%'}")
					.error-message.text-danger(v-if="errorMessage") {{ errorMessage }}
					.form-actions
						button.btn.btn-primary(type="button" :disabled="!files.length || uploading || completing" :class="{disabled: !files.length || uploading || completing}" @click="complete()")
							i.fa.fa-spinner.fa-spin(v-if="completing")
							i.fa.fa-check(v-else)
							span Complete
						button.btn.btn-warning(type="button" :disabled="uploading || completing" :class="{disabled: uploading || completing}" @click="openFileDialog()")
							i.fa.fa-spinner.fa-spin(v-if="uploading")
							i.fa.fa-upload(v-else)
							span {{ files.length ? 'Add size by psd' : 'Upload psd' }}
						button.btn.btn-dark(type="button" :disabled="completing" @click="cancel()") Cancel
</template>

<script>

	import Screen 				from './../../mixins/screen';
	import { Auth } from "../../services/Auth";

	import { Asset } 			from './../../services/Asset';
	import SetupSettings 		from "./../../settings/settings";
	import _ 					from "lodash";

	export default {
		name: "TemplateCreate",
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				// Сервер прислал данные временного шаблона: после загрузки json файла, после добавления/удаления psd файла размера
				"Server Data:TemporaryTemplate": function(temporaryTemplate, data) {

					this.temporaryTemplateId = data.TemporaryTemplateId;
					this.type = temporaryTemplate.type;
					this.title = temporaryTemplate.title;
					this.description = temporaryTemplate.description;
					this.files = temporaryTemplate.files || [];
					this.sizes = temporaryTemplate.sizes || [];
					this.errorMessage = '';

					this.stopUploading();

					if (!this.showed) this.show();

				},
				"Server Data:TemporaryTemplateError": function(errorMessage) {

					this.stopUploading();
					this.completing = false;

					if (this.showed) this.errorMessage = errorMessage;

				},
				"Server Data:TemporaryTemplateCanceled": function(temporaryTemplateId) {

					if (temporaryTemplateId === this.temporaryTemplateId) this.hide();

				},
				"Server Data:TemporaryTemplateCompleted": function(result) {

					if (result.temporaryTemplateId === this.temporaryTemplateId) this.hide();

				}
			}
		},
		data() {

			return {
				temporaryTemplateId: '',
				type: 'banner',
				title: '',
				description: '',
				files: [], // добавленные размеры (psd файлы): [{sizeKey, width, height, originalFilename}]
				sizes: [], // размеры, заявленные в json файле шаблона: [{width, height, title}]
				uploading: false,
				uploadProgress: 0,
				completing: false,
				errorMessage: ''
			};

		},
		beforeDestroy() {

			this.stopUploading();

		},
		computed: {
			// Объединяем размеры из json файла с уже загруженными psd файлами: заявленный размер без psd - красный, с psd - зелёный.
			// Psd файлы, размер которых не был заявлен в json - показываем отдельно, без названия
			displaySizes() {

				let declaredSizes = _.map(this.sizes, size => {

					let sizeKey = `${size.width}x${size.height}`;

					return {
						sizeKey,
						width: size.width,
						height: size.height,
						title: size.title,
						file: _.find(this.files, file => file.sizeKey === sizeKey)
					};

				});

				let extraFiles = _.filter(this.files, file => !_.find(declaredSizes, {sizeKey: file.sizeKey}));

				return declaredSizes.concat(_.map(extraFiles, file => ({
					sizeKey: file.sizeKey,
					width: file.width,
					height: file.height,
					title: '',
					file
				})));

			}
		},
		methods: {
			collectData() {

			},
			getTypeTitle() {

				return this.type === 'storyboard' ? 'storyboard' : 'banner';

			},
			stopUploading() {

				this.uploading = false;
				this.uploadProgress = 0;

				if (this.uploadTimeout) {

					clearTimeout(this.uploadTimeout);
					this.uploadTimeout = null;

				}

			},
			updateTemplate() {

				if (!this.temporaryTemplateId) return;

				Server.sendToSocket({
					UpdateTemporaryTemplate: {
						temporaryTemplateId: this.temporaryTemplateId,
						title: this.title,
						description: this.description
					}
				});

			},
			removeSize(file) {

				Server.sendToSocket({
					RemoveTemporaryTemplateSize: {
						temporaryTemplateId: this.temporaryTemplateId,
						sizeKey: file.sizeKey
					}
				});

			},
			openFileDialog() {

				if (this.uploading || this.completing) return;

				Asset.requestFile(".psd,.psb", file => {

					if (file) this.uploadPsdFile(file);

				});

			},
			uploadPsdFile(file) {

				this.uploading = true;
				this.uploadProgress = 0;
				this.errorMessage = '';

				if (this.uploadTimeout) clearTimeout(this.uploadTimeout);

				// На случай, если ответ от сервера так и не придёт - не оставляем кнопку заблокированной навсегда
				this.uploadTimeout = setTimeout(() => {

					this.stopUploading();

				}, 60000);

				let formData = new FormData();

				formData.append("file", file);
				formData.append("temporaryTemplateId", this.temporaryTemplateId);

				let url = `${location.protocol}//${SetupSettings["domain"]}/template/addTemporaryTemplateSize`;

				let xhr = new XMLHttpRequest();


				xhr.upload.addEventListener("progress", e => {

					if (e.lengthComputable) this.uploadProgress = e.loaded / e.total;

				});

				// Результат (обновлённый список размеров) придёт через сокет в Server Data:TemporaryTemplate
				xhr.open("POST", url);
				Auth.authorizeRequest(xhr);

				xhr.send(formData);

			},
			complete() {

				if (!this.files.length || this.uploading || this.completing) return;

				// Перед завершением отправляем последние title и description (на случай если поле ещё в фокусе и событие change не сработало)
				this.updateTemplate();

				this.completing = true;
				this.errorMessage = '';

				Server.sendToSocket({
					CompleteTemporaryTemplate: {
						temporaryTemplateId: this.temporaryTemplateId
					}
				});

			},
			cancel() {

				if (this.completing) return;

				if (this.temporaryTemplateId) {

					Server.sendToSocket({
						CancelTemporaryTemplate: {
							temporaryTemplateId: this.temporaryTemplateId
						}
					});

				}

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.template-create
		display: flex
		position: absolute
		z-index: 2100
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 600px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.card-header i
				margin-right: 10px

			input.title, textarea.description
				width: 100%
				margin-top: 5px

			textarea.description
				resize: vertical

			.sizes-list
				display: flex
				flex-direction: column
				margin-top: 5px
				max-height: 200px
				overflow-y: auto

				.size-item
					display: flex
					flex-direction: row
					align-items: center
					padding: 6px 10px
					margin-bottom: 5px
					border: 1px solid #4c4f54
					border-radius: 5px
					background-color: #343b41

					// Размер, заявленный в json, но пока без загруженного psd файла
					color: var(--red, #f86c6b)

					// Размер, для которого psd файл уже загружен
					&.filled
						color: var(--green, #4dbd74)

					.size
						font-weight: bold
						min-width: 160px

					.dimensions
						min-width: 80px
						text-align: center
						color: inherit
						opacity: 0.8

					.filename
						flex: 1
						overflow: hidden
						text-overflow: ellipsis
						white-space: nowrap
						margin: 0 10px
						color: #fff

					.remove
						cursor: pointer
						opacity: 0.6
						color: #fff
						// Область наведения/клика увеличена вдвое по площади, при этом визуальный размер иконки не меняется
						padding: 4px
						margin: -4px
						box-sizing: content-box

						&:hover
							opacity: 1
							color: var(--red, #f86c6b)

			.no-sizes
				margin-top: 5px

			.error-message
				margin-bottom: 10px

			.btn-warning, .btn-primary
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.progress.add-progress
				height: 5px
				margin-top: 10px
				margin-bottom: 10px

		.form-group
			display: flex
			flex-direction: column

	.template-create.hiding
		opacity: 0

		.card
			transform: scale(0.9)

</style>
